/**
 * Stage-transition copy shared by the site cockpit ("Do this next") and the
 * portfolio decision queue, so the two surfaces cannot drift apart on the same
 * site (twoActDerivation used to hand-write its own strings).
 */

/** CTA that opens the Stage 2 decision checklist. */
export const STAGE2_DECISIONS_CTA = 'Review Stage 2 decisions';

/** Headline while the accountable power strategy is undeclared after screening. */
export const POWER_STRATEGY_HEADLINE = 'Decide the power supply approach';

/** Headline while Stage 2 waits for a promoted generation scenario. */
export const PROMOTE_SCENARIO_HEADLINE = 'Promote a generation scenario';

/** "Do this next" headline for the Stage 2 checklist. */
export function stage2DecisionsHeadline(openCount: number, leadLabel: string): string {
  return openCount > 1
    ? `Review Stage 2 decisions (${openCount} open)`
    : `Decide: ${leadLabel}`;
}
